import { FC, InputHTMLAttributes, ReactElement } from 'react';
import './material-checkbox.scss';

type MaterialCheckboxProps = Omit<InputHTMLAttributes<HTMLInputElement>, 'title'> & {
    type: string;
    checked?: boolean;
    className?: string;
    id?: string;
    title?: ReactElement | string;
    checkedBgColor?: 'green' | 'dark';
};

const MaterialCheckbox: FC<MaterialCheckboxProps> = ({
    type = 'checkbox',
    title,
    className = '',
    checked,
    checkedBgColor = 'green',
    ...props
}) => {
    return (
        <div className={`material-checkbox ${className}`}>
            <input type={type} checked={Boolean(checked)} readOnly={!props.onChange} {...props} />
            <label htmlFor={props.id} className={checkedBgColor}>
                {title}
            </label>
        </div>
    );
};

export default MaterialCheckbox;
